import { ArrowUpRight, Bike } from "lucide-react";
import { BRAND, BOOKING, IMAGES } from "@/lib/site";
import { Reveal } from "./Reveal";

const facts = [
  ["Free Saturday window", "9:00 am – 12:00 pm"],
  ["Start times", "Every 30 minutes"],
  ["Capacity", "Up to 8 people in the area at once"],
  ["Last start", "11:30 am — wraps up by 12:00 pm"],
];

const PedalPop = () => {
  return (
    <section data-testid="pedal-pop-section" className="py-20 md:py-24 bg-coal border-y border-line/60">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        <Reveal className="lg:col-span-5">
          <div className="flex items-center gap-3">
            <span className="flex h-11 w-11 items-center justify-center border border-line bg-ink">
              <Bike className="h-5 w-5 text-ember" aria-hidden="true" />
            </span>
            <p className="text-xs tracking-[0.25em] uppercase font-medium text-rust">
              Free for {BRAND.parent} riders
            </p>
          </div>

          <img
            src={IMAGES.recoveryPop}
            alt="Recovery Pop"
            data-testid="recovery-pop-logo"
            className="mt-7 mx-auto h-24 sm:h-28 w-auto select-none"
          />

          <h2 className="mt-6 font-display text-2xl sm:text-3xl tracking-tight text-cream">
            Ride Saturday. Recover Saturday. Free.
          </h2>
          <p className="mt-5 text-base font-light leading-relaxed text-sand">
            Every Saturday morning TEMPA becomes{" "}
            <span className="text-cream font-medium">Recovery Pop</span> —{" "}
            {BRAND.parent}'s free post-ride recovery session. Roll in off the bike,
            hit the sauna, brave the ice and stretch it out on the deck, 9am to
            midday, on the house. Book through the Recovery Pop page — every
            attendee still sets up their own account and completes the forms
            before visiting.
          </p>
          <a
            href={BOOKING.pedalPop}
            data-testid="pedal-pop-bookings-button"
            className="group mt-8 inline-flex items-center gap-3 border border-line text-cream text-xs font-medium uppercase tracking-[0.18em] px-8 py-4 hover:bg-ink hover:border-stone2 transition-colors duration-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-rust"
          >
            Recovery Pop bookings
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" aria-hidden="true" />
          </a>
        </Reveal>

        <Reveal delay={0.12} className="lg:col-span-7">
          <dl className="grid sm:grid-cols-2 gap-px bg-line/60 border border-line/60">
            {facts.map(([label, value], i) => (
              <div key={label} data-testid={`pedal-fact-${i + 1}`} className="bg-coal p-7 md:p-8">
                <dt className="text-xs tracking-[0.2em] uppercase text-stone2">{label}</dt>
                <dd className="mt-2 text-lg font-light text-cream">{value}</dd>
              </div>
            ))}
          </dl>
        </Reveal>
      </div>
    </section>
  );
};

export default PedalPop;
